import { BREAKPOINTS_V3, sharedConfigV3 } from '@jouzen/ecom-components';
import type { Config } from 'tailwindcss';

import clipPlugin from './tailwind-plugins/clip';
import langPlugin from './tailwind-plugins/lang';
import noScrollbarPlugin from './tailwind-plugins/no-scrollbar';
import noJsPlugin from './tailwind-plugins/nojs';

const config: Config = {
  content: ['./src/**/*.{ts,jsx,tsx,mdx}', './src/**/*.module.scss'],
  important: '.tailwind',
  plugins: [clipPlugin, langPlugin, noJsPlugin, noScrollbarPlugin],
  prefix: '',
  presets: [sharedConfigV3],
  theme: {
    extend: {
      animation: {
        scrollTeaserPillSlide: 'scrollTeaserPillSlide 3s ease infinite',
      },
      aspectRatio: {
        '4/3': '4 / 3',
        '5/4': '5 / 4',
        '6/4': '6 / 4',
      },
      colors: {
        // holdover colors for the wizard
        burntOrange: {
          DEFAULT: '#CC612C',
        },
        gray: {
          50: '#ECE9E5',
          150: '#E2E1DA',
          250: '#ECECEC',
        },
      },
      keyframes: {
        scrollTeaserPillSlide: {
          '0%': {
            opacity: '0',
            transform: 'translate3d(-50%, 0, 0)',
          },
          '50%': {
            opacity: '1',
          },
          '100%': {
            opacity: '0',
            transform: 'translate3d(-50%, 32px, 0)',
          },
        },
      },
      lineHeight: {
        tighter: '1.1',
      },
      listStyleType: {
        none: 'none',
        disc: 'disc',
        decimal: 'decimal',
        circle: 'circle',
        'upper-roman': 'upper-roman',
        'lower-roman': 'lower-roman',
        'upper-alpha': 'upper-alpha',
        'lower-alpha': 'lower-alpha',
      },
      screens: {
        maxsm: {
          max: `${BREAKPOINTS_V3.small - 1}px`,
        },
        maxmd: {
          max: `${BREAKPOINTS_V3.medium - 1}px`,
        },
        maxlg: {
          max: `${BREAKPOINTS_V3.large - 1}px`,
        },
        maxxl: {
          max: `${BREAKPOINTS_V3.xLarge - 1}px`,
        },
        maxxxl: {
          max: `${BREAKPOINTS_V3.xxLarge - 1}px`,
        },
      },
      zIndex: {
        100: '100',
        150: '150',
        200: '200',
      },
    },
  },
};

export default config;
